import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import PageTitle from "../../common/PageTitle";
import TabHeader from "../../common/TabHeader";
import { TEXT_SUBTITLE } from "../../../style";

export default function ManagedListFrame({ bare, title, highlights, onAdd, children }) {

    if (bare) {
        return (
            <div className="px-3 pb-4">
                <div className="flex align-items-center justify-content-between gap-2 mb-2">
                    <span className={`${TEXT_SUBTITLE} font-semibold`}>{title}</span>
                    {onAdd ? <Button icon="pi pi-plus" severity="warning" onClick={onAdd} /> : null}
                </div>
                {children}
            </div>
        );
    }

    return (
        <div className="flex flex-column h-full">
            <PageTitle title={title} />
            <TabHeader
                className="px-3 pt-3"
                title={title}
                highlights={highlights}
                actionItems={[
                    onAdd ? <Button icon="pi pi-plus" severity="warning" onClick={onAdd} /> : null,
                ].filter(Boolean)}
            />
            <Divider />
            {children}
        </div>
    );
}
